import React, { useState, useEffect } from "react";
import {useForm} from "react-hook-form";
import axios from 'axios';
import GenericModal from '../../generic/modal';
import {
    Container,
    Button,
    Form,
  } from "react-bootstrap";

// import { css } from "@emotion/core";
// import CircleLoader from "react-spinners/CircleLoader";
import SyncLoader from "react-spinners/SyncLoader";
import ReactGA from 'react-ga';
import ReactStars from "react-rating-stars-component";
import ParseBooking from '../../parse-booking';


export default function ReviewVisit(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const [loading, setLoading] = useState(true);
    // const [email, setEmail] = useState('');
    const booking_id = props.match.params._id;
    console.log(booking_id);

    const [booking, setBooking] = useState({})
    const [bookingTime, setBookingTime] = useState("")
    const [success, setSuccess] = useState(false);
    const [stars, setStars] = useState(5);
    const [show, setShow] = useState(false);
    const {register, handleSubmit} = useForm();

    const ratingChanged = (newRating) => {
        setStars(newRating);
    };
  

    useEffect(() => {
        axios.post('https://uae-dentist-backend.herokuapp.com/schedule/find-booking', {_id: booking_id})
        .then(response=> {
            console.log(response);
            setBooking(response.data);
            setBookingTime(ParseBooking(response.data));
            setLoading(false);
        })
    },[booking_id]);


    const onSubmit = async (data) => {
        setLoading(true);
        data.rating = stars;
        const axiosConfig = {
            headers: {
                Authorization: props.match.params.token
            }
        };
        axios.post('https://uae-dentist-backend.herokuapp.com/schedule/review-visit', {data, booking}, axiosConfig)
        .then(function (response) {
            setLoading(false);
            setShow(true);
            setSuccess(true);
            console.log(response);
        })
        .catch(function (error) {
            setLoading(false);
            setShow(true);
            setSuccess(false);
            console.log(error);
        });
    }


    return (
    <Container className="mt-5">
        { show && <GenericModal setShow={setShow} show={show} success={success}/>}
        {!loading && 
                <Form onSubmit={handleSubmit(onSubmit)}>
                <h4 className="mb-4">Review your visit to {booking.dentist_name || ''} on {bookingTime}. </h4>
                <h6 className='mb-0'>Rating</h6>
                <ReactStars
                    className='mt-0'
                    count={5}
                    onChange={ratingChanged}
                    size={50}
                    isHalf={false}
                    emptyIcon={<i class="fa fa-star-o" aria-hidden="true"></i>}
                    fullIcon={<i class="fa fa-star" aria-hidden="true"></i>}
                    activeColor="#ffd700"
                />
        
                <Form.Group controlId="review">
                    <Form.Label>Write a review about {booking.dentist_name || ''}:</Form.Label>
                    <Form.Control placeholder="Please write your thoughts on the provider" as="textarea" rows="3" name="review" ref={register} />
                </Form.Group>
                <Button variant="primary" type="submit">Post Review</Button>
                </Form>
        }

        <div className='mt-5'>
          <SyncLoader
            size={15}
            margin={2}
            color={"#123abc"}
            loading={loading}
          />
        </div>
    </Container>
    )
}